import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import ScrollBar from "react-perfect-scrollbar"
import { useFormik } from "formik"
import * as Yup from "yup"
import InspectionNotSelected from "../InspectionNotSelected"
import ListOrder from "./components/ListOrder"
import InspectionChecklist from "./components/InspectionChecklist"
import DetailInspection from "./components/DetailInspection"
import AssignmentAction from "store/assignment-resource/actions"
import InspectionAction from "store/inspection-resource/actions"

export default function InpectionBespoke() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [selectedInspection, setSelectedInspection] = React.useState(null)
  const [tabs, setTabs] = React.useState([])
  console.log("tabs")
  console.log(tabs)

  const [filter, setFilter] = React.useState({
    weekId: "",
    keyword: "",
  })

  const [checkAllInspectorEditable, setCheckAllInspectorEditable] =
    useState(false)
  const [checkAllProducerEditable, setCheckAllProducerEditable] =
    useState(false)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      finishingPress: false,
      inseamDimension: false,
      waistSize: false,
      needleDetector: false,
      specificationConfirmation: false,
      summaryFestival: false,
      canStopStitch: false,
      attachButton: false,
      pocketBag: false,
      pocketOpeningCloth: false,
      brandName: false,
      qualityEntryConfirmation: false,
      garbage: false,
      hemBasting: false,
      remarks: "string",
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      values.id = selectedInspection
      setCheckAllInspectorEditable(false)
      setCheckAllProducerEditable(false)
      dispatch(InspectionAction.postOrderData(values, callbackPost))
    },
  })

  useEffect(() => {
    for (const key in validation.values) {
      if (key !== "remarks")
        validation.setFieldValue(key, checkAllInspectorEditable)
    }
  }, [checkAllInspectorEditable])

  useEffect(() => {
    for (const key in validation.values) {
      if (key !== "remarks")
        validation.setFieldValue(key, checkAllProducerEditable)
    }
  }, [checkAllProducerEditable])

  React.useEffect(() => {
    dispatch(AssignmentAction.getWeekList({}, callbackGetWeekList))
  }, [])

  const callbackGetWeekList = data => {
    const filtered = data.find(i => i.currentWeek)
    setFilter({
      ...filter,
      weekId: filtered.id,
      weekName: `${filtered.startDate} - ${filtered.endDate}`,
    })
    dispatch(InspectionAction.getOrderList({ ...filter, weekId: filtered.id }))
  }

  const callbackGetChecklist = data => {
    const editable = data.producerEditable ? data.producer : data.inspector
    validation.setValues(editable)
    validation.setFieldValue("remarks", data.remarks)
  }

  const callbackPost = () => {
    dispatch(
      InspectionAction.getOrderDetail(selectedInspection, callbackGetChecklist)
    )
  }

  const callbackGetDetailSize = data => {
    let temp = []
    Object.keys(data).map(i => {
      if (i == "jacket") {
        temp.push({
          title: "ジャケット",
          key: i,
        })
      } else if (i == "pants") {
        temp.push({
          title: "ジャケット",
          key: i,
        })
      } else if (i == "repair") {
        temp.push({
          title: "お直し",
          key: i,
        })
      }
    })

    setTabs(temp)
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"検品"} breadcrumbList={[]} />

        <Row>
          <Col xl="3" sm="6">
            <Card>
              <CardBody>
                <Row>
                  <Col md="4">
                    <Label>作業期間</Label>
                  </Col>
                  <Col md="8">
                    <Select
                      isLoading={store.assignment.weekList.loading}
                      value={{
                        value: filter.weekId,
                        label: filter.weekName,
                      }}
                      options={store.assignment.weekList.data.map(i => ({
                        value: i.id,
                        label: `${i.startDate} - ${i.endDate}`,
                      }))}
                      onChange={e => {
                        if (e) {
                          setFilter({
                            ...filter,
                            weekId: e.value,
                            weekName: e.label,
                          })
                          dispatch(
                            InspectionAction.getOrderList({
                              ...filter,
                              weekId: e.value,
                            })
                          )
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Input
                    value={filter.keyword}
                    placeholder="キーワード検索"
                    onChange={e => {
                      setFilter({ ...filter, keyword: e.target.value })
                      setTimeout(() => {
                        dispatch(
                          InspectionAction.getOrderList({
                            ...filter,
                            keyword: e.target.value,
                          })
                        )
                      }, 1000)
                    }}
                  />
                </Row>
              </CardBody>
            </Card>

            <Card style={{ height: 515 }}>
              <CardBody>
                <ScrollBar>
                  <ListOrder
                    setSelectedInspection={setSelectedInspection}
                    callbackGetChecklist={callbackGetChecklist}
                    setCheckAllInspectorEditable={setCheckAllInspectorEditable}
                    setCheckAllProducerEditable={setCheckAllProducerEditable}
                    callbackGetDetailSize={callbackGetDetailSize}
                    selectedInspection={selectedInspection}
                  />
                </ScrollBar>
              </CardBody>
            </Card>
          </Col>
          {!selectedInspection ? (
            <Col xl="9" sm="6" style={{ height: 660 }}>
              <InspectionNotSelected />
            </Col>
          ) : (
            <>
              <Col xl="4" sm="6">
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <InspectionChecklist
                    checkAllInspectorEditable={checkAllInspectorEditable}
                    setCheckAllInspectorEditable={setCheckAllInspectorEditable}
                    checkAllProducerEditable={checkAllProducerEditable}
                    setCheckAllProducerEditable={setCheckAllProducerEditable}
                    validation={validation}
                    selectedInspection={selectedInspection}
                  />
                </Form>
              </Col>
              <Col xl="5" sm="12">
                <DetailInspection tabs={tabs} />
              </Col>
            </>
          )}
          {/* </Col> */}
        </Row>
      </Container>
    </div>
  )
}
